import { Avatar, Box, HStack, Text } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";
import { SourceIcon } from "./ReviewCard.jsx";

export function TestimonialHighlight({ review }) {
  if (!review) return null;

  return (
    <Box
      maxW="container.md"
      mx="auto"
      my={{ base: 8, md: 12 }}
      px={{ base: 6, md: 10 }}
      py={{ base: 6, md: 8 }}
      borderLeftWidth="4px"
      borderLeftColor="accent"
      position="relative"
    >
      {/* Oversized decorative quote mark */}
      <Text
        position="absolute"
        top={{ base: "-6px", md: "-10px" }}
        left={{ base: "16px", md: "28px" }}
        fontSize={{ base: "6xl", md: "8xl" }}
        lineHeight="1"
        fontWeight="bold"
        color="accent"
        opacity={0.25}
        userSelect="none"
        aria-hidden="true"
      >
        &ldquo;
      </Text>

      <Text
        fontSize={{ base: "md", md: "lg" }}
        lineHeight="tall"
        fontStyle="italic"
        color="emphasized"
        pt={{ base: 4, md: 5 }}
      >
        {review.text}
      </Text>

      <HStack mt={5} spacing={3}>
        <Avatar
          size="sm"
          name={review.reviewerName}
          src={review.reviewerAvatar}
        />
        <Box>
          <Text fontSize="sm" fontWeight="semibold" color="emphasized">
            {review.reviewerName}
          </Text>
          <HStack spacing={1.5}>
            {(review.rating ||
              (review.source === "facebook" && review.isRecommended)) && (
              <HStack spacing="0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Box
                    key={i}
                    as={FaStar}
                    color={i <= (review.rating || 5) ? "warning" : "bg-muted"}
                    boxSize="12px"
                  />
                ))}
              </HStack>
            )}
            <SourceIcon source={review.source} sourceUrl={review.sourceUrl} />
          </HStack>
        </Box>
      </HStack>
    </Box>
  );
}
